import React from 'react'
import { array } from 'common/helpers'

import Cell from '../Cell/Cell'
import type { GridCellProps } from '../Cell/Cell'

/*

  Makes Cell fully flexible so that it absorbs any extra space

  <Grid columns={6}>
    <Grid.Cell>1</Grid.Cell>
    <Grid.Cell>2</Grid.Cell>
    <Grid.Cell>3</Grid.Cell>
    <LastFlexibleCell>4</LastFlexibleCell>
  </Grid>

  | 1 | 2 | 3 |    4    |


  LastFlexibleCell should be of size = 3

  [ 1, 2, 3, 4, 5, 6 ].find(...) =>
    (3 + 1) / 6 % 1 !== 0
    (3 + 2) / 6 % 1 !== 0
    (3 + 3) / 6 % 1 === 0 !!!
    (3 + 4) / 6 % 1 !== 0
    (3 + 5) / 6 % 1 !== 0
    (3 + 6) / 6 % 1 !== 0

  Result of .find() is 3

  BEWARE! LastFlexibleCell should be placed at the end of cells list! In other case it won't work!

 */

export type LastFlexibleGridCellProps = GridCellProps & {
  children: React.ReactElement
  index: number
}

const LastFlexibleCell: React.FunctionComponent<LastFlexibleGridCellProps> = ({ children, columns, gutter, index }) => {
  const sizes = array.range(1, columns)
  const size  = sizes.find((cellSize) => (index + cellSize) / columns % 1 === 0)

  return (
    <Cell columns={columns} size={size} gutter={gutter}>
      {
        Boolean(children) && React.cloneElement(children, { size })
      }
    </Cell>
  )
}


export default LastFlexibleCell
